import React from 'react';

const SocialButtons = () => (
    <ul className="app__social">
        <li className="socials__item">
            <a href="https://www.facebook.com/RTRussian" className="socials__link socials__link_facebook" title="Facebook">Facebook</a>
        </li>
        <li className="socials__item">
            <a href="https://www.instagram.com/rtrussian/" className="socials__link socials__link_instagram" title="Instagram">Instagram</a>
        </li>
        <li className="socials__item">
            <a href="https://twitter.com/RT_russian" className="socials__link socials__link_twitter" title="Twitter">Twitter</a>
        </li>
        <li className="socials__item">
            <a href="https://www.youtube.com/user/rtrussian" className="socials__link socials__link_youtube" title="YouTube">YouTube</a>
        </li>
    </ul>
);

export default SocialButtons;



// WEBPACK FOOTER //
// ./src/components/SocialButtons.jsx